import PublicRequestBase from "../rootRequest/PublicRequestBase";

export function signupRequest(payload) {
  return PublicRequestBase("post", "api/auth/registration/", payload)
}